import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
	Button,
	ButtonTypes,
	Card,
	CardContent,
	Loading,
} from "@repo/ui";
import { FC, useMemo } from "react";

import { useOnboardingSessionsApi } from "../../api/onboardingSessionsApi";
import { tabs } from "../../string";
import { SegmentUpdate } from "../summary/statusUpdate";
import { Req } from "./req";
import style from "./style.module.scss";
import { useSegmentWizard } from "./useSegmentWizard";

const reqList: Req[] = [
	{ id: "phoneNumber", href: tabs.personalInfo },
	{ id: "photo", href: tabs.personalInfo },
	{ id: "training", href: tabs.training },
	{ id: "bgCheck", href: tabs.bgChecks },
	{ id: "drugTest", href: tabs.drugTests },
	{ id: "documentation", href: tabs.documentation },
];

interface Props {
	id: number;
	title: string;
	status: string;
}

export const Enabled: FC<Props> = ({ id, title, status }) => {
	const { onboardingRequirementsQuery } = useOnboardingSessionsApi();
	const { openSegmentWizard } = useSegmentWizard();

	const requiredReqs = useMemo(() => {
		try {
			if (!onboardingRequirementsQuery.data) return [];

			const reqsRequiredOnOne = new Set<Req>();

			for (const reqDefinition of reqList) {
				const req = onboardingRequirementsQuery.data[reqDefinition.id].onboardingCompletion;
				for (const opReq of Object.values(req))
					if (opReq.required || opReq.contingentRequired) reqsRequiredOnOne.add(reqDefinition);
			}
			return Array.from(reqsRequiredOnOne); //reqs.map(k => k[id]).filter(r => r.required || r.contingentRequired);
		} catch (e) {
			console.error(e);
			return reqList;
		}
	}, [onboardingRequirementsQuery.data]);

	return (
		<Card>
			<Accordion type="multiple" defaultValue={["item-1"]} style={{ width: "100%" }}>
				<AccordionItem value="item-1" className={style.borderNone}>
					<AccordionTrigger className={style.accordionTriggerPadding}>
						<span>
							{title} <span className={style.textSmMuted}>({status})</span>
						</span>
					</AccordionTrigger>
					<AccordionContent>
						<Loading loading={onboardingRequirementsQuery.loading}>
							<CardContent>
								{requiredReqs?.length > 0 && (
									<div className={style.gridLayout}>
										{requiredReqs.map((item) => {
											const completion =
												onboardingRequirementsQuery.data?.[item.id].onboardingCompletion?.[id];

											if (!completion) return null;

											return <Req key={item.id} req={item} completion={completion} />;
										})}
									</div>
								)}
								<div className={style.flexBetween}>
									<SegmentUpdate repSegmentId={id} repId={undefined} />
									{import.meta.env.DEV && (
										<Button
											types={[ButtonTypes.Outline]}
											onClick={() => openSegmentWizard(id, title)}
										>
											Open Segment Wizard
										</Button>
									)}
								</div>
							</CardContent>
						</Loading>
					</AccordionContent>
				</AccordionItem>
			</Accordion>
		</Card>
	);
};
